
<aside class="main-sidebar">

        <section class="sidebar">

            <div class="user-panel">
                <div class="pull-left image">
                    <img src="assets/img/user1.jpg" class="img-circle" alt="User Image">
                </div>
                <div class="pull-left info">
                    <p>{{authService.getLoggedUsername()}}</p>
                    <a href="#">
                        <i class="fa fa-circle text-success"></i> Online</a>
                </div>
            </div>

            <!-- ADMIN AND SUPER ADMIN -->
            <ul *ngIf="authorizeService.IsAdmin() || authorizeService.IsSuperAdmin()" class="sidebar-menu"
                data-widget="tree">
                <li routerLinkActive="active">
                    <!-- <a routerLink="/dashboard"   data-toggle="push-menu"> -->
                    <a routerLink="/dashboard" class="mobile_menu">
                        <i class="fa fa-dashboard"></i>
                        <span>Dashboard</span>
                    </a>
                </li>
                <li routerLinkActive="active">
                    <a routerLink="/account" class="mobile_menu">
                        <i class="fa fa-users"></i>
                        <span>Account</span>
                    </a>
                </li>
                <li routerLinkActive="active">
                    <a routerLink="/daily-report" class="mobile_menu">
                        <i class="fa fa-calendar-minus-o"></i>
                        <span>Daily Report</span>
                    </a>
                </li>

                <!-- <li routerLinkActive="active">
                    <a routerLink="/wasa-recharge-request" class="mobile_menu">
                        <i class="fa fa-calendar-minus-o"></i>
                        <span>Recharge Request</span>
                    </a>
                </li> -->

                <li routerLinkActive="active">
                    <a routerLink="/recharge" class="mobile_menu">
                        <i class="fa fa-money"></i>
                        <span>Recharge</span>
                    </a>
                </li>
                <li routerLinkActive="active">
                    <a routerLink="/bkashtransaction" class="mobile_menu">
                        <i class="fa fa-money"></i>
                        <span>BKash Transaction</span>
                    </a>
                </li>
                <li routerLinkActive="active">
                    <a routerLink="/water-transaction" class="mobile_menu">
                        <i class="fa fa-server"></i>
                        <span>Water Transaction</span>
                    </a>
                </li>
                <li routerLinkActive="active">
                    <a routerLink="/card" class="mobile_menu">
                        <i class="fa fa-credit-card"></i>
                        <span>Card</span>
                    </a>
                </li>

                <li class="treeview" [class.menu-open]="isSettingOpen">
                    <button (click)="openSettingMenu()">
                        <i class="fa fa-cog"></i>
                        <span>Setting</span>
                        <span class="pull-right-container">
                            <i class="fa fa-angle-left pull-right"></i>
                        </span>
                    </button>
                    <ul class="treeview-menu">
                        <li routerLinkActive="active">
                            <a routerLink="/setting/zone" class="mobile_menu">
                                <i class="fa fa-map-marker"></i> Zone</a>
                        </li>
                        <li routerLinkActive="active">
                            <a routerLink="/setting/vendor" class="mobile_menu">
                                <i class="fa fa-industry"></i> Vendor</a>
                        </li>
                        <li routerLinkActive="active">
                            <a routerLink="/setting/booth" class="mobile_menu">
                                <i class="fa fa-map-signs"></i> Pump</a>
                        </li>
                        <li routerLinkActive="active">
                            <a routerLink="/setting/device" class="mobile_menu">
                                <i class="fa fa-fax"></i> ATM</a>
                        </li>
                        <li routerLinkActive="active">
                            <a routerLink="/setting/cost" class="mobile_menu">
                                <i class="fa fa-cc-mastercard"></i> Cost</a>
                        </li>
                        <li routerLinkActive="active">
                            <a routerLink="/setting/user" class="mobile_menu">
                                <i class="fa fa-user-o"></i> User</a>
                        </li>
                    </ul>
                </li>

                <li class="treeview" [class.menu-open]="isLogOpen">
                    <button (click)="openLogMenu()">
                        <i class="fa fa-cog"></i>
                        <span>Log</span>
                        <span class="pull-right-container">
                            <i class="fa fa-angle-left pull-right"></i>
                        </span>
                    </button>
                    <ul class="treeview-menu">

                        <li routerLinkActive="active" >
                            <a routerLink="/Log/DashboardAuditLog" class="mobile_menu">
                                <i class="fa fa-history" aria-hidden="true"></i>Dashboard AuditLog </a>
                        </li>
                        <li routerLinkActive="active" >
                            <a routerLink="/Log/UserHistory" class="mobile_menu">
                                <i class="fa fa-history" aria-hidden="true"></i> User History</a>
                        </li>
                        <li routerLinkActive="active" >
                                <a routerLink="/Log/DeviceLog" class="mobile_menu">
                                    <i class="fa fa-history" aria-hidden="true"></i> Device AuditLog</a>
                            </li>
                            <li routerLinkActive="active" >
                                <a routerLink="/Log/LoginLog" class="mobile_menu">
                                    <i class="fa fa-history" aria-hidden="true"></i> Login Log</a>
                            </li>

                            <!-- <li routerLinkActive="active" >
                                <a routerLink="/Log/ServerResponseLog" class="mobile_menu">
                                    <i class="fa fa-history" aria-hidden="true"></i> Server Response Log</a>
                            </li> -->
                            <!-- <li routerLinkActive="active" >
                                <a routerLink="/Log/Request-Response-Dispense-Count" class="mobile_menu">
                                    <i class="fa fa-history" aria-hidden="true"></i> Log Analysis</a>
                            </li> -->
                            
                            <li routerLinkActive="active">
                                <a routerLink="/Log/BkashpayloadLog" class="mobile_menu">
                                    <i class="fa fa-industry"></i> BkashpayloadLog</a>
                            </li>
                        <!-- <li routerLinkActive="active">
                            <a routerLink="/Log/ExceptionLog" class="mobile_menu">
                                <i class="fa fa-industry"></i> ExceptionLog</a>
                        </li> -->

                    </ul>
                </li>

                <li class="treeview"  [class.menu-open]="isReportOpen">
                    <button class="mobile_menu" (click)="openReportMenu()">
                        <i class="fa fa-print" aria-hidden="true"></i>
                         <span>Report</span>
                        <span class="pull-right-container">
                            <i class="fa fa-angle-left pull-right"></i>
                        </span>
                    </button>
                    <ul class="treeview-menu">
                        <li routerLinkActive="active">
                            <a routerLink="/report/atm-water-dispensed" class="mobile_menu">
                                <i class="fa fa-file-o"></i> ATM wise Water Dispense</a>
                        </li>
                        <li routerLinkActive="active">
                            <a routerLink="/report/customer-water-dispensed" class="mobile_menu">
                                <i class="fa fa-file-o" aria-hidden="true"></i> Customer wise Water Dispense </a>
                        </li>
                        <li routerLinkActive="active">
                            <a routerLink="/report/recharge-revenue" class="mobile_menu">
                                <i class="fa fa-file-o" aria-hidden="true"></i> Pump Recharge </a>
                        </li>
                        <li routerLinkActive="active">
                            <a routerLink="/report/registered-customer" class="mobile_menu">
                                <i class="fa fa-file-o" aria-hidden="true"></i> Registered customer </a>
                        </li>
                        <li routerLinkActive="active">
                            <a routerLink="/report/customer-recharge" class="mobile_menu">
                                <i class="fa fa-file-o" aria-hidden="true"></i> Customer recharge </a>
                        </li>
                        <li routerLinkActive="active">
                            <a routerLink="/report/customer-dispense" class="mobile_menu">
                                <i class="fa fa-file-o" aria-hidden="true"></i> Customer water dispense </a>
                        </li>
                        <!-- <li routerLinkActive="active">
                            <a routerLink="/report/pump-wise-transaction" class="mobile_menu">
                                <i class="fa fa-file-o" aria-hidden="true"></i> Pump wise water transaction </a>
                        </li> -->
                    </ul>
                </li>
            </ul>

            <!-- PUMP OPERATOR -->
            <ul *ngIf="authorizeService.IsPumpOperator()" class="sidebar-menu" data-widget="tree">
                <li routerLinkActive="active">
                    <a routerLink="/dashboard">
                        <i class="fa fa-dashboard"></i>
                        <span>Dashboard</span>
                    </a>
                </li>
                <li routerLinkActive="active">
                    <a routerLink="/account">
                        <i class="fa fa-users"></i>
                        <span>Account</span>
                    </a>
                </li>
                <li routerLinkActive="active">
                    <a routerLink="/recharge">
                        <i class="fa fa-money"></i>
                        <span>Recharge</span>
                    </a>
                </li>
                <li routerLinkActive="active">
                    <a routerLink="/card">
                        <i class="fa fa-credit-card"></i>
                        <span>Card</span>
                    </a>
                </li>
            </ul>

            <!-- DATA OPERATOR -->
            <ul *ngIf="authorizeService.IsDataOperator()" class="sidebar-menu" data-widget="tree">
                <!-- <li routerLinkActive="active">
                    <a routerLink="/dashboard">
                        <i class="fa fa-dashboard"></i>
                        <span>Dashboard</span>
                    </a>
                </li> -->
                <li routerLinkActive="active">
                    <a routerLink="/account">
                        <i class="fa fa-users"></i>
                        <span>Account</span>
                    </a>
                </li>
            </ul>

            <!-- GOVT ADMIN -->
            <ul *ngIf="authorizeService.IsGovtAdmin()" class="sidebar-menu" data-widget="tree">
                <li routerLinkActive="active">
                    <a routerLink="/dashboard">
                        <i class="fa fa-dashboard"></i>
                        <span>Dashboard</span>
                    </a>
                </li>
                <li routerLinkActive="active">
                    <a routerLink="/wasa-recharge-request" class="mobile_menu">
                        <i class="fa fa-calendar-minus-o"></i>
                        <span>Recharge Request</span>
                    </a>
                </li>
            </ul>

        </section>
    </aside>
